module.exports = __webpack_public_path__ + "img/CS48Q-中_07.f81af811.jpg";